export default {
  SET_METADATA (state, {origin, formated}) {
    state.userRoles = origin.user_roles
    state.engines = origin.engines
    state.reports = origin.reports
    state.selectEngines = formated.engines
    state.selectUserRoles = formated.userRoles
  }
}



// WEBPACK FOOTER //
// ./src/store/metadata/mutations.js